import api from './api';

const successStoriesService = {
  async list() {
    const response = await api.get('/partners/success-stories');
    return response.data;
  },

  async create(data) {
    const response = await api.post('/partners/success-stories', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`/partners/success-stories/${id}`, data);
    return response.data;
  },

  async publish(id, publish = true) {
    const response = await api.post(`/partners/success-stories/${id}/publish`, { publish });
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/partners/success-stories/${id}`);
    return response.data;
  }
};

export default successStoriesService;
